// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media only screen and (min-width:1121px){.view-chat .chat[data-v-d65e2e8e],.view-chat .chat-placeholder[data-v-d65e2e8e]{margin:0 auto;max-width:650px;-webkit-box-shadow:0 0 56px 0 rgba(0,0,0,.34);box-shadow:0 0 56px 0 rgba(0,0,0,.34)}}", ""]);
// Exports
module.exports = exports;
